let videoReelsPopup;
let currentVideo;
let isShowVideoReelsPopup = false;
let forcePause = false;

function throttle(mainFunction, delay) {
  let timerFlag = null; // Variable to keep track of the timer

  // Returning a throttled version 
  return (...args) => {
    if (timerFlag === null) { // If there is no timer currently running
      mainFunction(...args); // Execute the main function 
      timerFlag = setTimeout(() => { // Set a timer to clear the timerFlag after the specified delay
        timerFlag = null; // Clear the timerFlag to allow the main function to be executed again
      }, delay);
    }
  };
}

function setupCountdown($el) {
  const endDate = new Date($el.data("time")).getTime();

  // Update the count down every 1 second
  var interval = setInterval(function() {

    // Get today's date and time
    var now = new Date().getTime();
  
    // Find the distance between now and the count down date
    var distance = endDate - now;
  
    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
    // Display the result in the element with id="demo"
    $(".days", $el).text(String(days).padStart(2, "0"));
    $(".hours", $el).text(String(hours).padStart(2, "0"));
    $(".minutes", $el).text(String(minutes).padStart(2, "0"));
    $(".seconds", $el).text(String(seconds).padStart(2, "0"));
  
    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(interval);
    }
  }, 1000);
}

function setupVideoReelsEvent() {
  $("#video-reels video").on("play", function() {
    $(this).parent(".video").addClass("playing");
    currentVideo = this;
  });

  $("#video-reels video").on("pause", function() {
    $(this).parent(".video").removeClass("playing");
    this.currentTime = 0;
    currentVideo = null;
    
    const $time = $(this).parent(".video").find(".video-current-time");
    $time.css("width", "0%");
  });

  $("#video-reels video").on("timeupdate", function() {
    const time = this.currentTime;
    const duration = this.duration;
    const percent = Math.floor((time / duration) * 100);

    $(this).parent(".video").find(".video-current-time").css("width", `${percent}%`);
  })
}

function setupVideoReelsControl() {
  $(".video-reels .video").on("click", function() {
    if (currentVideo && !currentVideo.paused) {
      currentVideo.pause();
    }

    if (videoReelsPopup.selectedScrollSnap() != this.dataset.index) {
      videoReelsPopup.scrollTo(this.dataset.index, true);
    }
    
    const video = videoReelsPopup.slideNodes()[this.dataset.index].querySelector("video");
    video.play();
    
    isShowVideoReelsPopup = true;
    document.body.style.overflow = "hidden";
    $(".video-reels-popup").css("display", "block");
  });
  
  $(".video-reels .video").on("mouseenter touchstart", function(e) {
    const video = this.querySelector("video");

    if (!video.paused) return;

    if (currentVideo && video != currentVideo) {
      currentVideo.pause();
    }

    video.play();

    $(this).one("mouseleave", () => {
      video.pause();
    });
  });

  $(window).on("touchstart", function(e) {
    if (!$(e.target).is("video") && currentVideo && !currentVideo.paused && !isShowVideoReelsPopup) {
        currentVideo.pause();
    }
  });

  const emblaNode = document.querySelector('.embla__carousel');
  const viewportNode = emblaNode.querySelector('.embla__viewport');

  const prevButtonNode = emblaNode.querySelector('.embla__prev');
  const nextButtonNode = emblaNode.querySelector('.embla__next');
  
  const options = { 
    dragFree: true,
    loop: true,
    slidesToScroll: 1,
    breakpoints: {
      '(min-width: 744px)': {
        slidesToScroll: 2,
      },
      '(min-width: 1024px)': {
        slidesToScroll: 3,
      }
    }
  };
  const emblaApi = EmblaCarousel(viewportNode, options);
  
  prevButtonNode.addEventListener('click', emblaApi.scrollPrev, false);
  nextButtonNode.addEventListener('click', emblaApi.scrollNext, false);
}

function setupVideoReelsPopupControl() {
  $(".video-reels-popup .video").on("click", function() {
    const video = this.querySelector("video");

    if (!video.paused) {
      video.pause();
      forcePause = true;
    } else {
      video.play();
      forcePause = false;
    }
  });
  
  const emblaNode = document.querySelector('.video-reels-popup .embla__carousel');
  const viewportNode = emblaNode.querySelector('.embla__viewport');

  const prevButtonNode = emblaNode.querySelector('.embla__prev');
  const nextButtonNode = emblaNode.querySelector('.embla__next');
  const closeButtonNode = emblaNode.querySelector('.popup-close-btn');
  
  const options = { 
    dragFree: false,
    loop: true,
    slidesToScroll: 1,
  };
  const emblaApi = EmblaCarousel(viewportNode, options, [EmblaCarouselClassNames()]);

  emblaApi.on("scroll", throttle(function() {
    const index = emblaApi.selectedScrollSnap();
    const video = emblaApi.slideNodes()[index].querySelector("video");

    if (currentVideo == video) {
      if (video.paused) video.play();
    } else {
      if (currentVideo && !currentVideo.paused) {
        currentVideo.pause();
      }
      
      video.play();
      currentVideo = video;
    }
  }, 1000));

  prevButtonNode.addEventListener('click', emblaApi.scrollPrev, false);
  nextButtonNode.addEventListener('click', emblaApi.scrollNext, false);
  
  closeButtonNode.addEventListener('click', function(e) {
    if (currentVideo) {
      currentVideo.pause();
    };

    $(".video-reels-popup").css("display", "none");
    document.body.style.overflow = "auto";
    isShowVideoReelsPopup = false;
  }, false);

  videoReelsPopup = emblaApi;
}

function FDTabControl() {
  var tabs = $('.tabs');
  
  tabs.find('a').on('click', function(event) {
    event.preventDefault();
    
    var target = $(this).attr('href'),
        tabs = $(this).parents('.tabs'),
        buttons = tabs.find('a'),
        item = tabs.parents('.section__content').find('.tab-content__wrapper');
    buttons.removeClass('active');
    item.removeClass('active');
    $(this).addClass('active');
    $(target).addClass('active');
  });
}

function initCarousel(el) {
 $(el).slick({
    mobileFirst: true,
    dots: false,
    slidesToShow: 1,
    variableWidth: true,
    infinite: false,
    prevArrow: `<button class="prev">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 0.5C13.0767 0.5 15.1068 1.11581 16.8335 2.26957C18.5602 3.42332 19.906 5.0632 20.7007 6.98182C21.4955 8.90045 21.7034 11.0116 21.2982 13.0484C20.8931 15.0852 19.8931 16.9562 18.4246 18.4246C16.9562 19.8931 15.0852 20.8931 13.0484 21.2982C11.0116 21.7034 8.90044 21.4955 6.98182 20.7007C5.0632 19.906 3.42332 18.5602 2.26957 16.8335C1.11581 15.1068 0.499996 13.0767 0.499996 11C0.503685 8.21636 1.61112 5.54779 3.57945 3.57945C5.54778 1.61112 8.21636 0.503689 11 0.5ZM7.75812 11.6169L12.5706 16.4294C12.6516 16.5104 12.7478 16.5746 12.8536 16.6185C12.9595 16.6623 13.0729 16.6849 13.1875 16.6849C13.3021 16.6849 13.4155 16.6623 13.5213 16.6185C13.6272 16.5746 13.7234 16.5104 13.8044 16.4294C13.8854 16.3484 13.9496 16.2522 13.9935 16.1464C14.0373 16.0405 14.0599 15.9271 14.0599 15.8125C14.0599 15.6979 14.0373 15.5845 13.9935 15.4786C13.9496 15.3728 13.8854 15.2766 13.8044 15.1956L9.61312 11L13.8044 6.80437C13.968 6.64077 14.0599 6.41887 14.0599 6.1875C14.0599 5.95613 13.968 5.73423 13.8044 5.57063C13.6408 5.40702 13.4189 5.31511 13.1875 5.31511C12.9561 5.31511 12.7342 5.40702 12.5706 5.57063L7.75812 10.3831C7.67605 10.4635 7.61085 10.5595 7.56634 10.6654C7.52183 10.7714 7.49891 10.8851 7.49891 11C7.49891 11.1149 7.52183 11.2286 7.56634 11.3346C7.61085 11.4405 7.67605 11.5365 7.75812 11.6169Z" fill="#379BEE"/>
                    <path d="M7.75817 11.617L12.5707 16.4295C12.6517 16.5105 12.7478 16.5747 12.8537 16.6186C12.9595 16.6624 13.073 16.685 13.1875 16.685C13.3021 16.685 13.4156 16.6624 13.5214 16.6186C13.6272 16.5747 13.7234 16.5105 13.8044 16.4295C13.8854 16.3484 13.9497 16.2523 13.9935 16.1464C14.0374 16.0406 14.0599 15.9271 14.0599 15.8126C14.0599 15.698 14.0374 15.5846 13.9935 15.4787C13.9497 15.3729 13.8854 15.2767 13.8044 15.1957L9.61317 11.0001L13.8044 6.80445C13.968 6.64085 14.0599 6.41895 14.0599 6.18758C14.0599 5.95621 13.968 5.73431 13.8044 5.5707C13.6408 5.4071 13.4189 5.31519 13.1875 5.31519C12.9562 5.31519 12.7343 5.4071 12.5707 5.5707L7.75817 10.3832C7.6761 10.4636 7.6109 10.5596 7.56639 10.6655C7.52188 10.7714 7.49896 10.8852 7.49896 11.0001C7.49896 11.115 7.52188 11.2287 7.56639 11.3346C7.6109 11.4406 7.6761 11.5365 7.75817 11.617Z" fill="white"/>
                  </svg>
                </button>`,
    nextArrow: `<button class="next">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 3.5C11.9233 3.5 9.89323 4.11581 8.16652 5.26957C6.4398 6.42332 5.09399 8.0632 4.29927 9.98182C3.50455 11.9004 3.29661 14.0116 3.70176 16.0484C4.1069 18.0852 5.10693 19.9562 6.57538 21.4246C8.04383 22.8931 9.91476 23.8931 11.9516 24.2982C13.9884 24.7034 16.0996 24.4955 18.0182 23.7007C19.9368 22.906 21.5767 21.5602 22.7304 19.8335C23.8842 18.1068 24.5 16.0767 24.5 14C24.4963 11.2164 23.3889 8.54779 21.4206 6.57945C19.4522 4.61112 16.7836 3.50369 14 3.5ZM17.2419 14.6169L12.4294 19.4294C12.3484 19.5104 12.2522 19.5746 12.1464 19.6185C12.0405 19.6623 11.9271 19.6849 11.8125 19.6849C11.6979 19.6849 11.5845 19.6623 11.4787 19.6185C11.3728 19.5746 11.2766 19.5104 11.1956 19.4294C11.1146 19.3484 11.0504 19.2522 11.0065 19.1464C10.9627 19.0405 10.9401 18.9271 10.9401 18.8125C10.9401 18.6979 10.9627 18.5845 11.0065 18.4786C11.0504 18.3728 11.1146 18.2766 11.1956 18.1956L15.3869 14L11.1956 9.80437C11.032 9.64077 10.9401 9.41887 10.9401 9.1875C10.9401 8.95613 11.032 8.73423 11.1956 8.57063C11.3592 8.40702 11.5811 8.31511 11.8125 8.31511C12.0439 8.31511 12.2658 8.40702 12.4294 8.57063L17.2419 13.3831C17.3239 13.4635 17.3891 13.5595 17.4337 13.6654C17.4782 13.7714 17.5011 13.8851 17.5011 14C17.5011 14.1149 17.4782 14.2286 17.4337 14.3346C17.3891 14.4405 17.3239 14.5365 17.2419 14.6169Z" fill="#379BEE"/>
                    <path d="M17.2418 14.617L12.4293 19.4295C12.3483 19.5105 12.2522 19.5747 12.1463 19.6186C12.0405 19.6624 11.927 19.685 11.8125 19.685C11.6979 19.685 11.5844 19.6624 11.4786 19.6186C11.3728 19.5747 11.2766 19.5105 11.1956 19.4295C11.1146 19.3484 11.0503 19.2523 11.0065 19.1464C10.9626 19.0406 10.9401 18.9271 10.9401 18.8126C10.9401 18.698 10.9626 18.5846 11.0065 18.4787C11.0503 18.3729 11.1146 18.2767 11.1956 18.1957L15.3868 14.0001L11.1956 9.80445C11.032 9.64085 10.9401 9.41895 10.9401 9.18758C10.9401 8.95621 11.032 8.73431 11.1956 8.5707C11.3592 8.4071 11.5811 8.31519 11.8125 8.31519C12.0438 8.31519 12.2657 8.4071 12.4293 8.5707L17.2418 13.3832C17.3239 13.4636 17.3891 13.5596 17.4336 13.6655C17.4781 13.7714 17.501 13.8852 17.501 14.0001C17.501 14.115 17.4781 14.2287 17.4336 14.3346C17.3891 14.4406 17.3239 14.5365 17.2418 14.617Z" fill="white"/>
                  </svg>
                </button>`
  });
}

function destroyCarousel(el) {
  $(el).slick("unslick");
}

function checkCarousel() {
  const $tabs = $(".tabs");
  const containerWidth = $(".section__content").width();
  let itemsWidth = 0;
  
  $tabs.each(function(index, tab) {
    let itemsWidth = 0;
    
    $(tab).find(".item").each(function(index, el) {
      itemsWidth += $(el).outerWidth();
    });
    
    if (containerWidth < itemsWidth && !$(tab).hasClass("slick-initialized")) {
      initCarousel(tab);
    }
  
    if (containerWidth >= itemsWidth && $(tab).hasClass("slick-initialized")) {
      destroyCarousel(tab);
    }
  });
}

$(function() { 
  const $countdown = $(".hero__countdown");

  setupCountdown($countdown);
  
  FDTabControl();
  
  $(".tabs .item__title").each(function(index, el) {
    const title = $(el).text();
    const words = title.split(" ");
    $(el).html(words[0] + " <br /> " + words.slice(1).join(" "));
  });

  $(window).on("resize", checkCarousel);
  checkCarousel();

  setupVideoReelsEvent();
  setupVideoReelsControl();
  setupVideoReelsPopupControl();
});